import { Button, CircularProgress } from "@mui/material";
import { useStyles } from "./SummaryReportFilters.styles";
import { useTranslation } from "react-i18next";
import useMillFilters, { initialMillFilters } from "./useMillFilters";
import DateRange from "components/DateRange/DateRange.view";
import FilterSelect from "components/MainSelect/MainSelect.view";

const SummaryReportFilters = () => {
    const classes = useStyles();
    const {
        productionLinesOptions,
        machineCentersOptions,
        functionalLocationsOptions,
        shiftsOptions,
        displayInOptions,
        failureTypesOptions,
        isLoading,
        filters,
        applyFilters,
        resetFilters,
        handleFiltersChange,
    } = useMillFilters();
    const { t } = useTranslation();

    if (isLoading) {
        return (
            <div className={`${classes.mainWrapper} ${classes.mainWrapperLoading}`}>
                <CircularProgress color="info" />
            </div>
        );
    }

    return (
        <div className={classes.mainWrapper}>
            <div className={classes.filtersWrapper}>
                <DateRange
                    placeholderText={t("locations.summary_report.filters.select_date_range")}
                    startDate={filters.startDate}
                    endDate={filters.endDate}
                    onChange={(update) => {
                        const [start, end] = update as [Date, Date];
                        handleFiltersChange({ startDate: start, endDate: end });
                    }}
                    label={t("locations.summary_report.filters.select_report")}
                />
                <FilterSelect
                    label={t("locations.summary_report.filters.production_line")}
                    options={productionLinesOptions}
                    value={filters.productionLine}
                    onChange={(event) =>
                        handleFiltersChange({
                            productionLine: event.target.value,
                            machineCenter: initialMillFilters.machineCenter,
                            functionalLocation: initialMillFilters.functionalLocation,
                            failureTypes: initialMillFilters.failureTypes,
                        })
                    }
                />
                <FilterSelect
                    multiple
                    label={t("locations.summary_report.filters.machine_center")}
                    options={machineCentersOptions}
                    value={filters.machineCenter}
                    onChange={(event) =>
                        handleFiltersChange({
                            machineCenter: event.target.value,
                            functionalLocation: initialMillFilters.functionalLocation,
                            failureTypes: initialMillFilters.failureTypes,
                        })
                    }
                />
                <FilterSelect
                    label={t("locations.summary_report.filters.functional_location")}
                    options={functionalLocationsOptions}
                    value={filters.functionalLocation}
                    onChange={(event) => handleFiltersChange({ functionalLocation: event.target.value })}
                />
                <FilterSelect
                    label={t("locations.summary_report.filters.shift")}
                    options={shiftsOptions}
                    value={filters.shift}
                    onChange={(event) => handleFiltersChange({ shift: event.target.value })}
                />
                <FilterSelect
                    label={t("locations.summary_report.filters.display_in")}
                    options={displayInOptions}
                    value={filters.displayIn}
                    onChange={(event) => handleFiltersChange({ displayIn: event.target.value })}
                />
                <FilterSelect
                    multiple
                    label={t("locations.summary_report.filters.failure_type")}
                    options={failureTypesOptions}
                    value={filters.failureTypes}
                    onChange={(event) =>
                        handleFiltersChange({
                            failureTypes: event.target.value,
                        })
                    }
                />
            </div>
            <div className={classes.filtersActionsWrapper}>
                <div className={classes.link} onClick={() => resetFilters()}>
                    {t("locations.summary_report.filters.clear_filters")}
                </div>
                <Button
                    variant="contained"
                    color="info"
                    disabled={!filters.startDate || !filters.endDate}
                    onClick={() => applyFilters()}
                >
                    {t("locations.summary_report.filters.apply_filters")}
                </Button>
            </div>
        </div>
    );
};

export default SummaryReportFilters;
